import { createAction } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const continueFormSubmit = createAction("".concat(stateName, "/continueFormSubmit"));